import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  values: {
    weight: "",
    height: "",
  },
};

const numberSlice = createSlice({
  name: "number",
  initialState,
  reducers: {
    setNumberValue: (state, action) => {
      const { key, value } = action.payload;
      state.values[key] = value;
    },
  },
});

export const { setNumberValue } = numberSlice.actions;
export default numberSlice.reducer;
